module.exports = __webpack_public_path__ + "static/media/Autograph-Regular.5269006b.otf";